import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Calendar from "react-calendar";
import MiniCalendar from "../calendarpage/MiniCalendar";
import {
  Button,
  Card,
  Divider,
  IconButton,
  OutlinedInput,
  styled,
} from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  ArrowBack,
  CalendarMonth,
  CalendarMonthRounded,
  Event,
  Phone,
} from "@mui/icons-material";
import { addMinutes, format } from "date-fns";
import { gql, useQuery } from "@apollo/client";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import { getBookings, getUsers } from "../../graphql/querys";

function ConfirmPage(props) {
  const { bookingId } = useParams();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const {
    loading: usersLoading,
    error: usersError,
    data: usersData,
  } = useQuery(getUsers);
  const { loading, error, data, refetch } = useQuery(getBookings, {
    fetchPolicy: "network-only",
  });
  const navigate = useNavigate();

  if (loading || usersLoading) return "Loading";
  if (error || usersError) return <Error />;

  const bookingData = data.getBookings.find(
    (obj) => obj.bookingId == bookingId
  );
  const eventData = props.all.find(
    (obj) => parseInt(obj.id) == bookingData.eventId
  );

  const handleChange = (setState) => (event) => {
    setState(event.target.value);
  };

  const handleGoBack = () => {
    navigate(-1); // Go back one step in the browser's history
  };

  const time = new Date(bookingData.time);
  const user = "Robel";

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Card
        className="event-card"
        style={{
          display: "flex",
          width: "90%",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "800px",
          height: "700px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "60%",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: "1000px",
            height: "700px",
            marginTop: "20px",
            maxWidth: "450px",
          }}
        >
          <h3 style={{ height: "0px" }}>Confirmed!</h3>
          <h4 className="input-label">
            You are now booked with{" "}
            {
              usersData.users.find(
                (obj) => parseInt(obj.id) == parseInt(eventData.userId)
              ).username
            }
            .
          </h4>
          <Divider style={{ width: "100%" }} />
          <div
            style={{
              gap: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              className="circle"
              style={{ background: eventData.color }}
            ></div>
            <h3 style={{ fontWeight: 500 }}>{eventData.name}</h3>
          </div>
          <div
            style={{
              gap: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              height: "50px",
            }}
          >
            <CalendarMonth />
            <h4 style={{ fontWeight: 500 }}>
              {format(new Date(time), HourFormat()).toLowerCase() +
                " - " +
                format(
                  addMinutes(new Date(time), eventData.length),
                  HourFormat()
                ).toLowerCase()}
            </h4>
          </div>
          <div
            style={{
              gap: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              height: "50px",
            }}
          >
            <Event />
            <h4 style={{ fontWeight: 500 }}>
              {format(new Date(time), "EEEE, MMMM d, yyyy")}
            </h4>
          </div>
          <div
            style={{
              gap: "20px",
              width: "100%",
              display: eventData?.phoneNumberRadio ? "flex" : "none",
              alignItems: "center",
              height: "50px",
            }}
          >
            <Phone />
            <h4 style={{ fontWeight: 500 }}>{eventData.phoneNumber}</h4>
          </div>
          <h4>A calendar invitation has been sent to your email address.</h4>
          <Divider style={{ width: "100%" }} />
          <div style={{ textAlign: "center" }}>
            <h4>Confirmation Id:</h4>
            <p>{bookingId}</p>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default ConfirmPage;
